var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Welcome!")]),_c('p',[_vm._v(" Welcome to the Commerce Center! We hope to meet your banking and shopping needs! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }